export default __webpack_public_path__ + "static/media/defaultprofile.d7b01b2e.png";